export default __webpack_public_path__ + "static/media/hand_heart.31827fc4.svg";